import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-collapse-view",
  templateUrl: "./collapse-view.component.html",
  styleUrls: ["./collapse-view.component.scss"],
})
export class CollapseViewComponent implements OnInit {
  constructor() {}
  @Input() title: string = "Toggle"; // Optional title input for the collapse button
  @Input() body: string = ""; // Content input for the collapsible body

  isCollapsed = true;

  ngOnInit(): void {}
}
